export const STATION_VIEWER_TEXTS = {
	editData: 'Edit data',
};
